import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Candidate|Program History|Achievements|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialAchievements,
	portal: 'SP',
};
const columnHeadingDescriptionStart = 'Column heading for: ';

type LocNameStart = 'SPCandidateHistoryAchievements';
export type SPCandidateHistoryAchievementsLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelFilterByType`
	| `${LocNameStart}LabelFilterByGroup`
	| `${LocNameStart}LabelFilterByStatus`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelGroup`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelLogo`
	| `${LocNameStart}LabelPdf`;

export const spCandidateHistoryAchievementsLocs: LocDefs<SPCandidateHistoryAchievementsLocNames> = {
	SPCandidateHistoryAchievementsTitleSection: {
		defaultValue: 'Achievements',
		description: 'Page Section Title',
		displayPath: `${pathStart}Page Section Title`,
		displayType: 'Title',
		legacyName: 'Credential.Achievements/Candidates.Achievements.Title.Achievements',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsTitleTab: {
		defaultValue: 'Achievements',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Credential.Achievements/Candidates.Achievements.Title.Tab',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelFilterByType: {
		defaultValue: 'Filter by Type',
		description: 'Label for: Filter by Type.',
		displayPath: `${pathStart}Filter by Type`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.FieldLabel.TypeFilter',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelFilterByGroup: {
		defaultValue: 'Filter by Group',
		description: 'Label for: Filter by Group.',
		displayPath: `${pathStart}Filter by Group`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.FieldLabel.GroupFilter',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelFilterByStatus: {
		defaultValue: 'Filter by Status',
		description: 'Label for: Filter by Status.',
		displayPath: `${pathStart}Filter by Status`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.FieldLabel.StatusFilter',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelType: {
		defaultValue: 'Type',
		description: `${columnHeadingDescriptionStart}Type.`,
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.Type',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelGroup: {
		defaultValue: 'Group',
		description: `${columnHeadingDescriptionStart}Group.`,
		displayPath: `${pathStart}Group`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.Group',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelName: {
		defaultValue: 'Name',
		description: `${columnHeadingDescriptionStart}Name.`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelStatus: {
		defaultValue: 'Status',
		description: `${columnHeadingDescriptionStart}Status.`,
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.Status',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelActiveDate: {
		defaultValue: 'Active Date',
		description: `${columnHeadingDescriptionStart}Active Date.`,
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: `${columnHeadingDescriptionStart}Expire Date.`,
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelLogo: {
		defaultValue: 'Logo',
		description: `${columnHeadingDescriptionStart}Logo.`,
		displayPath: `${pathStart}Logo`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.Logo',
		...sharedProperties,
	},
	SPCandidateHistoryAchievementsLabelPdf: {
		defaultValue: 'PDF',
		description: `${columnHeadingDescriptionStart}PDF.`,
		displayPath: `${pathStart}PDF`,
		displayType: 'Label',
		legacyName: 'Credential.Achievements/Candidates.Achievements.ColumnHeading.Pdf',
		...sharedProperties,
	},
};

export type SPCandidateHistoryAchievementsLocType = LocMap<SPCandidateHistoryAchievementsLocNames>;
